<template>
  <div>
    <div class="wrap">
      <div class="module">
        <div class="module_item"
             :style="child.colorType=='1'?'border: 1px solid #f3f4f5;background:linear-gradient(to bottom,'+child.bgColorStart+','+child.bgColorEnd+')':'border: 3px solid'+child.borderColor+';'"
             v-for="(child,childIndex) in goodsList"
             :key="child.id"
             v-show="child.swiperList.length!=0">
          <div class="navBar"
               :style="child.colorType=='1'?'border-color:'+child.bgColorEnd+';':'border-color:'+child.borderColor+';'">
            <div class="title"
                 :style="'color:'+child.titleColor">{{ child.title }}</div>
            <div style="display: flex;align-items: center;"
                 @click="jumpGoodsList(child)">
              <span class="more">更多</span>
              <div class="right">
                <i class="el-icon-arrow-right"
                   :style="'font-size:14px;color:'+txtColor"></i>
              </div>
            </div>
          </div>
          <div class="goodsBox"
               v-if="childIndex%2==0">
            <div class="right">
              <swiper class="swiper"
                      :options="child.swiperOption"
                      ref="swiperTop">
                <swiper-slide class="swiper-slide"
                              v-for="(swiper,index) in child.swiperList"
                              :key="index">
                  <div class="cake">
                    <img :src="child.mainImg"
                         alt=""
                         class="module_img"
                         v-if="index==0">
                    <div style="display: flex;justify-content: center;"
                         v-for="(item,i) in swiper"
                         :key="i">
                      <div class="item"
                           @click.stop="jumpDetail(item)"
                           :data-v='JSON.stringify(item)'>
                        <img :src="item.picUrl"
                             :data-v='JSON.stringify(item)'
                             alt=""
                             class="img">
                        <div class="info">
                          <div class="name">{{ item.name }}</div>
                          <div class="num">已售{{ item.salesCount }}</div>
                          <div class="price"><span>￥</span>{{ (Number(item.price)/100).toFixed(2) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <div class="goodsBox"
               v-else>
            <div class="right">
              <swiper class="swiper"
                      :options="child.swiperOption"
                      ref="swiperTop">
                <swiper-slide class="swiper-slide"
                              v-for="(swiper,index) in child.swiperList"
                              :key="index">
                  <div class="cake">
                    <img :src="child.mainImg"
                         alt=""
                         class="module_img2"
                         v-if="index==0">
                    <div style="display: flex;justify-content: center;"
                         v-for="item in swiper"
                         :key="item.id">
                      <div class="item"
                           @click.stop="jumpDetail(item)"
                           :data-v='JSON.stringify(item)'>
                        <img :src="item.picUrl"
                             :data-v='JSON.stringify(item)'
                             alt=""
                             class="img">
                        <div class="info">
                          <div class="name">{{ item.name }}</div>
                          <div class="num">已售{{ item.salesCount }}</div>
                          <div class="price"><span>￥</span>{{ (Number(item.price)/100).toFixed(2) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'modulPage',
  data () {
    return {
      swiperOptionTop: {
        loop: false,
        loopedSlides: 5,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        on: {
          click: (event) => {
            if (event.target.getAttribute('data-v')) {
              // 这里的 obj 就是当前点击图片所对应的信息
              let obj = JSON.parse(event.target.getAttribute('data-v'))
              this.jumpDetail(obj)
            }
          }
        }
      },
      swiperList: [],
      goodsList: [],
    };
  },
  created () {
    this.$store.dispatch('saveCategoryTitle', '')
    this.$store.dispatch('saveLayoutId', '')

  },
  mounted () {
    this.getLayoutList()
  },
  computed: {
    ...mapState(['cakeCityId', 'cakeCityName', 'floatStatus', 'backColors', 'fontsColor', 'txtColor', 'themeColor'])
  },
  watch: {
    // cakeCityId (newValue, oldValue) {
    //   console.log(newValue, oldValue);
    //   if (newValue != oldValue) {
    //     this.getCakeList()
    //   }
    // }
  },
  methods: {
    // 跳转更多
    jumpGoodsList (item) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveLayoutId', item.id)
      this.$store.dispatch('saveCategoryTitle', item.title)
      this.$router.push({
        name: "layoutGoodsList",
      });
    },
    // 跳转商品详情
    jumpDetail (item) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (item.productType == 1) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$store.dispatch('saveModeType', 1)
        this.$router.push({
          name: "jdDetail",
        });
      } else {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', 1)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "detail",
        });
      }
    },
    getLayoutList () {
      this.$api.mall.getLayoutList().then((res) => {
        console.log(res, '布局');
        if (res.code == 200) {
          let data = !res.data ? [] : res.data
          this.goodsList = data
          if (data.length) {
            data.forEach((item, index) => {
              this.getGoodsList(item.id, index)
              item.swiperList = []
              item.swiperOption = {
                loop: false,
                loopedSlides: 5,
                on: {
                  click: (event) => {
                    if (event.target.getAttribute('data-v')) {
                      // 这里的 obj 就是当前点击图片所对应的信息
                      let obj = JSON.parse(event.target.getAttribute('data-v'))
                      this.jumpDetail(obj)
                    }
                  }
                }
              }
              // for (let i = 0; i < 3; i++) {
              //   let arr = []
              //   for (let j = 14 * i; j < (i + 1) * 14; j++) {
              //     arr.push(item.productSpuList[j])
              //   }
              //   item.swiperList.push(arr)
              // }
              // if (item.productSpuList.length <= 10) {
              //   item.swiperOption.loop = false
              // } else {
              //   item.swiperOption.loop = true
              // }
            });
          }
          console.log(data, 204);
        }
        this.$forceUpdate()
      });
    },
    getGoodsList (id, index) {
      this.$api.mall.getSpuList({
        layoutId: id,
        count: 42
      }).then((res) => {
        console.log(res, '商品列表');
        if (res.code == 200) {
          let data = !res.data ? [] : res.data
          if (data.length != 0) {
            let swiper = []
            for (let i = 0; i < 3; i++) {
              let arr = []
              for (let j = 14 * i; j < (i + 1) * 14; j++) {
                arr.push(data[j])
              }
              swiper.push(arr)
            }
            this.goodsList[index].swiperList = swiper
            if (data.length <= 14) {
              this.goodsList[index].swiperOption.loop = false
            } else {
              this.goodsList[index].swiperOption.loop = true
            }
          }
          console.log(this.goodsList, 252);

        }
        this.$forceUpdate()

      })
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  .module {
    width: 100%;

    .module_item {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      margin-top: 25px;
      border-radius: 10px;
      box-sizing: border-box;
    }
    .navBar {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px 0;
      box-sizing: border-box;
      border-bottom: 5px solid transparent;
      .title {
        font-size: 32px;
        font-weight: bold;
        color: #000000;
      }
      .more {
        font-size: 16px;
        font-weight: bold;
        margin-right: 5px;
      }
      .right {
        width: 16px;
        height: 16px;
        border: 2px solid #000000;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          color: #000000 !important;
          font-weight: bold;
        }
      }
    }
    .goodsBox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      border-radius: 3px;
      background-color: #ffffff;
      margin-top: 10px;
      .right {
        flex: 1;
        overflow: hidden;
        .swiper {
          width: 100%;
          // height: 450px;
          .swiper-slide {
            width: 1060px;
            // height: 450px;
          }
        }
        .cake {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: flex-start;
          padding: 5px 10px;
          box-sizing: border-box;
          position: relative;
          .module_img {
            width: 413px;
            height: 292px;
            display: inline-block;
            position: absolute;
            top: 10px;
            left: 10px;
            z-index: 4;
          }
          .module_img2 {
            width: 413px;
            height: 292px;
            display: inline-block;
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 4;
          }
          .item {
            width: 200px;
            box-sizing: border-box;
            background-color: #ffffff;
            box-shadow: 0px 0px 4px 3px rgba(0, 0, 0, 0.05);
            margin: 5px 0;
            .img {
              width: 100%;
              height: 200px;
              display: inline-block;
            }
            .info {
              width: 100%;
              height: 88px;
              background-color: #fff;
              padding: 10px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              border-radius: 0 0 8px 8px;
              .name {
                width: 100%;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-break: break-all;
              }
              .num {
                width: 100%;
                text-align: center;
                font-size: 12px;
                color: #999999;
              }
              .price {
                width: 100%;
                font-size: 16px;
                color: #e60012;
                text-align: center;
                span {
                  font-size: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>